<template>
  <material-card offset="75" class="ma-2 pa-3">
    <v-avatar tile color="white" slot="offset" size="160" width="400" class="mx-auto d-block elevation-8">
      <v-img contain width="90%" :src="imgSrc"></v-img>
    </v-avatar>

    <v-card-text style="position:relative">
      <div v-if="profile.firstname || profile.lastName">
        <p class="subheading">Imię i nazwisko</p>

        <p class="title">{{ profile.firstName }} {{ profile.lastName }}</p>
      </div>

      <div v-if="profile.city">
        <p class="subheading">Adres</p>

        <p class="title">{{ profile | address }}</p>
      </div>

      <div v-if="profile.email">
        <p class="subheading">Adres e-mail</p>

        <p class="title">{{ profile.email }}</p>
      </div>

      <div v-if="profile.phoneNumber">
        <p class="subheading">Numer telefonu</p>

        <p class="title">{{ profile.phoneNumber }}</p>
      </div>

      <div v-if="profile.pesel">
        <p class="subheading">Pesel</p>

        <p class="title">{{ profile.pesel }}</p>
      </div>

      <div v-if="profile.gender">
        <p class="subheading">Płeć</p>

        <p class="title">{{ profile.gender | gender }}</p>
      </div>
    </v-card-text>

    <v-layout justify-center row wrap slot="actions">
      <check-permission joinType="OR" entityType="profile" :permissions="updatePermissions" :entityId="profile.id">
        <v-btn dark flat color="blue darken-2" @click="showEditModal"> <v-icon left>edit</v-icon>Edytuj </v-btn>
      </check-permission>

      <check-permission permissions="ACCOUNT.PASSWORD.RESET" entityType="profile" :entityId="profile.id">
        <v-btn dark flat color="blue darken-2" @click="showPasswordDialog">
          <v-icon left>lock</v-icon>Resetuj hasło
        </v-btn>
      </check-permission>

      <check-permission
        v-if="roleLinkField"
        joinType="OR"
        entityType="profile"
        :entityId="profile.id"
        :permissions="['USER.ROLE_MANAGE', 'PERMISSION_RELATION.ADD', 'PERMISSION_RELATION.DELETE']"
      >
        <router-link :to="{ name: roleLinkField, params: { [`${roleLinkParam}`]: profile.userId } }">
          <v-btn dark flat color="blue darken-2"> <v-icon left>mdi-sitemap</v-icon>role </v-btn>
        </router-link>
      </check-permission>
    </v-layout>

    <material-dialog
      cancelText="Anuluj"
      confirmText="Wyślij"
      title="Reset hasła"
      :text="passwordText"
      :width="450"
      :id="profile.id"
      :show="passwordDialog"
      @close="hidePasswordDialog"
      @confirm="sendConfirmation"
    ></material-dialog>
  </material-card>
</template>

<script>
import { GenderTranslation, Gender, isOfficial, sharedConfig, address } from '@witkac/kartamiejska-shared';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import { resetPasswordMixin } from '@/mixins/resetPassword';
import { config } from '@/utils/config';

// @vuese
// Wyświetlanie tabeli z danymi klienta
// @group Client-Profile
export default {
  components: { MaterialCard, MaterialDialog },
  mixins: [resetPasswordMixin],
  props: {
    // Dane profilu
    profile: {
      type: Object,
      required: true
    },
    // Link do roli
    roleLinkField: {
      type: String,
      required: false,
      default: undefined
    },
    // Param roli
    roleLinkParam: {
      type: String,
      required: false,
      default: 'id'
    },
    // Uprawnienia do edycji
    updatePermissions: {
      type: [Array, String],
      required: true
    }
  },
  methods: {
    // @vuese
    // Funkcja wywołuje modal do edycji danych klienta
    showEditModal() {
      this.$emit('showEditModal');
    }
  },
  computed: {
    imgSrc() {
      if (this.profile.mainImage) {
        return `${config.mediaURL}/${this.profile.mainImage}?${sharedConfig.sizes.avatar.medium.queryString}`;
      }
      const avatarNumber = this.profile.gender === Gender.FEMALE ? 1 : 2;
      return `/img/ava${avatarNumber}.png`; // Tymczasowo na sztywno przypisane
    },
    isOfficial
  },
  filters: {
    gender(val) {
      return GenderTranslation[val];
    },
    address
  }
};
</script>
